import React, {useEffect, useState} from "react"
import {message, Modal, Tabs} from "antd"
import {
    getClubMemberTrackBill,
    getClubMemberTrackBound,
    getClubMemberTrackBuy, getClubMemberTrackWeekly
} from "../../../../../../api/clubMemberList"
import ClubMemberFindTrackBill from "./component/ClubMemberFindTrackBill"
import ClubMemberFindTrackBuy from "./component/ClubMemberFindTrackBuy"
import ClubMemberFindTrackBounds from "./component/ClubMemberFindTrackBounds"
import ClubMemberFindTrackWeekly from "./component/ClubMemberFindTrackWeekly"

const ClubMemberFindTrack = ({memberId}) => {
    const TAB_TYPE = {
        BILL: 1,
        BUY: 2,
        BONUS: 3,
        PURCHASE: 4
    }
    const initPage = {
        page: 1,
        total: 0,
        count: 10
    }


    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const [billPage, setBillPage] = useState(initPage)
    const [buyPage, setBuyPage] = useState(initPage)
    const [boundPage, setBoundPage] = useState(initPage)

    const [billRecord, setBillRecord] = useState([])
    const [buyRecord, setBuyRecord] = useState([])
    const [boundRecord, setBoundRecord] = useState([])
    const [weeklyRecord, setWeeklyRecord] = useState([])

    const handleClick = async () => {
        setIsShow(true)
        await fetchMemberBillRecord()
    }


    const fetchMemberBillRecord = async () => {
        setIsLoading(true)
        await getClubMemberTrackBill(memberId, billPage.page).then((res) => {
            setBillRecord(res.list)
            setBillPage(prevState => {
                return {
                    ...prevState,
                    total: res.count
                }
            })
        }).catch(err => {
            message.error(`获取结账记录失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const fetchMemberBuyRecord = async () => {
        setIsLoading(true)
        await getClubMemberTrackBuy(memberId, buyPage.page).then((res) => {
            setBuyRecord(res.list)
            setBuyPage(prevState => {
                return {
                    ...prevState,
                    total: res.count
                }
            })
        }).catch(err => {
            message.error(`获取购买记录失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const fetchMemberBoundRecord = async () => {
        setIsLoading(true)
        await getClubMemberTrackBound(memberId, boundPage.page).then((res) => {
            setBoundRecord(res.list)
            setBoundPage(prevState => {
                return {
                    ...prevState,
                    total: res.count
                }
            })
        }).catch(err => {
            message.error(`获取奖金记录失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const fetchClubMemberTrackWeekly = async () => {
        setIsLoading(true)
        await getClubMemberTrackWeekly(memberId).then((res) => {
            setWeeklyRecord(res.list)
        }).catch(err => {
            message.error(`获取常够商品记录失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }


    const handleTabOnChange = async (key) => {
        switch (key) {
            case 1:
                await fetchMemberBillRecord()
                break
            case 2:
                await fetchMemberBuyRecord()
                break
            case 3:
                await fetchMemberBoundRecord()
                break
            case 4:
                await fetchClubMemberTrackWeekly()
                break
        }
    }

    const handleOnPageChange = async (page, type) => {
        switch (type) {
            case TAB_TYPE.BILL:
                setBillPage(prevState => {
                    return {
                        ...prevState,
                        page: page
                    }
                })
                break
            case TAB_TYPE.BUY:
                setBuyPage(prevState => {
                    return {
                        ...prevState,
                        page: page
                    }
                })
                break
            case TAB_TYPE.BONUS:
                setBoundPage(prevState => {
                    return {
                        ...prevState,
                        page: page
                    }
                })
                break
        }
    }


    useEffect(() => {
        if (isShow) {
            fetchMemberBillRecord()
        }
    }, [billPage.page])

    useEffect(() => {
        if (isShow) {
            fetchMemberBuyRecord()
        }
    }, [buyPage.page])

    useEffect(() => {
        if (isShow) {
            fetchMemberBoundRecord()
        }
    }, [boundPage.page])


    const items = [
        {
            label: "结账记录",
            key: 1,
            children: (<ClubMemberFindTrackBill
                loading={isLoading}
                datasource={billRecord}
                total={billPage.total}
                onPageChange={(page) => handleOnPageChange(page, TAB_TYPE.BILL)}
            />)
        },
        {
            label: "购买记录",
            key: 2,
            children: (<ClubMemberFindTrackBuy
                loading={isLoading}
                datasource={buyRecord}
                total={buyPage.total}
                onPageChange={(page) => handleOnPageChange(page, TAB_TYPE.BUY)}
            />)
        },
        {
            label: "奖金记录",
            key: 3,
            children: (<ClubMemberFindTrackBounds
                loading={isLoading}
                datasource={boundRecord}
                total={boundPage.total}
                onPageChange={(page) => handleOnPageChange(page, TAB_TYPE.BONUS)}
            />)
        }, {
            label: "常购商品",
            key: 4,
            children: (<ClubMemberFindTrackWeekly
                loading={isLoading}
                datasource={weeklyRecord}
            />)
        }
    ]


    return (
        <div>
            <div onClick={handleClick}>操作足迹</div>
            <Modal
                open={isShow}
                onCancel={() => {
                    setIsShow(false)
                }}
                width={1200}
                destroyOnClose
                title={"操作足迹"}
            >
                <Tabs
                    defaultActiveKey={1}
                    items={items}
                    onChange={handleTabOnChange}
                />

            </Modal>

        </div>
    )

}

export default ClubMemberFindTrack


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberFind/component/ClubMemberFindTrack/ClubMemberFindTrack.js